import { render, staticRenderFns } from "./AdminStudents.vue?vue&type=template&id=29ed2f84&scoped=true"
import script from "./AdminStudents.vue?vue&type=script&lang=js"
export * from "./AdminStudents.vue?vue&type=script&lang=js"
import style0 from "./AdminStudents.vue?vue&type=style&index=0&id=29ed2f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ed2f84",
  null
  
)

export default component.exports